import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

/** Shared date-range filter for the whole Diwali admin page (cards, charts
 * and the donor table below all key off this) + the manual Refresh button -
 * deliberately no auto-polling, data only reloads on mount or on click. */
export default function DiwaliFilters({ range, onChange, onRefresh, refreshing }) {
  return (
    <div className="flex flex-wrap items-end gap-3 mb-5" data-testid="diwali-admin-filters">
      <div>
        <Label htmlFor="diwali-start">From</Label>
        <Input
          id="diwali-start"
          type="date"
          value={range.start}
          onChange={(e) => onChange({ ...range, start: e.target.value })}
          data-testid="diwali-start-date-input"
          className="mt-1.5 h-10"
        />
      </div>
      <div>
        <Label htmlFor="diwali-end">To</Label>
        <Input
          id="diwali-end"
          type="date"
          value={range.end}
          onChange={(e) => onChange({ ...range, end: e.target.value })}
          data-testid="diwali-end-date-input"
          className="mt-1.5 h-10"
        />
      </div>
      <Button type="button" variant="outline" onClick={onRefresh} disabled={refreshing} data-testid="diwali-refresh-button">
        <RefreshCw className={`h-4 w-4 mr-2 ${refreshing ? "animate-spin" : ""}`} /> Refresh
      </Button>
    </div>
  );
}
